<div class="ws-page laris-loc-page" [class.laris-loc-page--dimmed]="formModalOpen() || lidarModalOpen()">

  <header class="page-head">

    <div>

      <p class="kicker">Building enforcement</p>

      <div class="page-head-title-row">
        <app-page-back-btn />
        <h2>Locations</h2>
        <app-page-refresh-btn [loading]="loading()" (refresh)="reload()" />
      </div>

      <p class="loc-page-lead">Browse the full hierarchy on this page. Click any location to open its form in a modal over a blurred background.</p>

    </div>

  </header>



  <p class="toast loc-toast" *ngIf="toast()">{{ toast() }}</p>

  <p class="error" *ngIf="error()">{{ error() }}</p>



  <p class="loc-loading" *ngIf="loading()">Loading locations…</p>

  <div class="loc-hierarchy-page page-card" *ngIf="!loading()">
    <header class="loc-tree-head">
      <h3 class="loc-tree-title">Location hierarchy</h3>
      <div class="loc-tree-tools">
        <button type="button" class="loc-tree-tool" (click)="expandAll()">Expand all</button>
        <button type="button" class="loc-tree-tool" (click)="collapseAll()">Collapse all</button>
      </div>
    </header>

    <label class="loc-tree-search">
      <span class="visually-hidden">Search locations</span>
      <input
        type="search"
        placeholder="Search by name or code…"
        [value]="treeFilter()"
        (input)="onTreeFilter($any($event.target).value)"
      />
    </label>

    <p class="loc-tree-hint">Click any Zone, Sector, or Plot to open its entry form in a popup with a blurred background.</p>

    <div class="loc-tree-empty" *ngIf="!visibleTree().length">
      <ng-container *ngIf="treeFilter(); else noLocations">No locations match your search.</ng-container>
      <ng-template #noLocations>Nothing here yet — use “Add location” below.</ng-template>
    </div>

    <div class="loc-tree loc-tree--full" role="tree" aria-label="Location hierarchy">
      <ng-container *ngFor="let node of visibleTree()">
        <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: node, depth: 0 }"></ng-container>
      </ng-container>
    </div>

    <button type="button" class="btn primary loc-add-btn" *ngIf="canManageLocations()" (click)="openAddLocation()">
      + Add location
    </button>
  </div>
</div>



<ng-template #treeNode let-node let-depth="depth">

  <div

    class="loc-tree-node"

    role="treeitem"

    [attr.aria-expanded]="node.children.length ? isExpanded(node.location.id) : null"

    [attr.aria-level]="depth + 1"

    [attr.aria-selected]="selectedId() === node.location.id"

  >

    <div

      class="loc-tree-row"

      [class.loc-tree-row--selected]="selectedId() === node.location.id"

      [style.--tree-depth]="depth"

    >

      <button

        type="button"

        class="loc-tree-toggle"

        *ngIf="node.children.length; else treeSpacer"

        [attr.aria-label]="isExpanded(node.location.id) ? 'Collapse' : 'Expand'"

        (click)="toggleExpand(node.location.id, $event)"

      >

        <span class="loc-tree-chevron" [class.loc-tree-chevron--open]="isExpanded(node.location.id)"></span>

      </button>

      <ng-template #treeSpacer><span class="loc-tree-spacer" aria-hidden="true"></span></ng-template>



      <button type="button" class="loc-tree-label" (click)="selectLocation(node.location.id)">

        <span class="loc-type-icon loc-type-icon--sm" [ngClass]="'loc-type-icon--' + typeTone(node.location.locationTypeName)">

          {{ typeInitial(node.location.locationTypeName) }}

        </span>

        <span class="loc-tree-text">

          <span class="loc-tree-name">{{ node.location.name }}</span>

          <span class="loc-tree-meta">{{ node.location.code }} · {{ node.location.locationTypeName }}</span>

        </span>

        <span class="loc-tree-count" *ngIf="node.children.length">{{ node.children.length }}</span>

      </button>

    </div>



    <div class="loc-tree-children" *ngIf="node.children.length && isExpanded(node.location.id)" [style.--tree-depth]="depth">

      <ng-container *ngFor="let child of node.children">

        <ng-container *ngTemplateOutlet="treeNode; context: { $implicit: child, depth: depth + 1 }"></ng-container>

      </ng-container>

    </div>

  </div>

</ng-template>

<div class="loc-form-overlay" *ngIf="formModalOpen()" (click)="closeFormModal()">
  <div
    class="loc-form-sheet"
    role="dialog"
    aria-modal="true"
    aria-labelledby="locFormTitle"
    (click)="$event.stopPropagation()"
  >
    <header class="loc-form-sheet-head">
      <div>
        <p class="loc-form-sheet-kicker" *ngIf="detail() as loc">{{ loc.locationTypeName }}</p>
        <h3 id="locFormTitle">{{ detail() ? formTitle(detail()!) : 'Loading…' }}</h3>
      </div>
      <button type="button" class="loc-form-close" (click)="closeFormModal()" aria-label="Close">×</button>
    </header>

    <p class="loc-loading" *ngIf="detailLoading()">Loading form…</p>

    <ng-container *ngIf="!detailLoading() && detail() as loc">
      <nav class="loc-path" aria-label="Selected path" *ngIf="selectionPath().length">
        <ng-container *ngFor="let step of selectionPath(); let last = last">
          <button type="button" class="loc-path-step" [class.loc-path-step--current]="last" (click)="selectLocation(step.id)">
            {{ step.name }}
          </button>
          <span class="loc-path-sep" *ngIf="!last" aria-hidden="true">›</span>
        </ng-container>
      </nav>

      <form
        class="loc-edit-form loc-edit-form--sheet"
        [ngClass]="'loc-edit-form--' + typeTone(loc.locationTypeName)"
        (ngSubmit)="submitEditLocation()"
      >
        <p class="loc-form-lead">{{ formLead(loc) }}</p>

        <ng-container [ngSwitch]="selectedTypeCode()">
          <p class="loc-form-context" *ngSwitchCase="'AUTHORITY'">Top-level development authority. Add zones under this node.</p>
          <p class="loc-form-context" *ngSwitchCase="'ZONE'">Parent authority: <strong>{{ parentLocationLabel() }}</strong>. Add sectors inside this zone.</p>
          <p class="loc-form-context" *ngSwitchCase="'SECTOR'">Parent zone: <strong>{{ parentLocationLabel() }}</strong>. {{ childCount(loc.id) }} plot{{ childCount(loc.id) === 1 ? '' : 's' }} registered here.</p>
          <p class="loc-form-context" *ngSwitchCase="'PLOT'">Parent sector: <strong>{{ parentLocationLabel() }}</strong>. Used for measurements and rule checks.</p>
          <p class="loc-form-context" *ngSwitchDefault>Parent: <strong>{{ parentLocationLabel() }}</strong>.</p>
        </ng-container>

        <section class="loc-form-section">
          <h4 class="loc-form-section-title">{{ basicSectionTitle(loc) }}</h4>
          <label class="laris-field">Name *<input [(ngModel)]="editForm.name" name="editName" [readonly]="!canManageLocations()" required /></label>
          <label class="laris-field">Code *<input [(ngModel)]="editForm.code" name="editCode" [readonly]="!canManageLocations()" required /></label>
        </section>

        <section class="loc-form-section" *ngIf="loc.fields?.length">
          <h4 class="loc-form-section-title">{{ attributesSectionTitle(loc) }}</h4>
          <label class="laris-field" *ngFor="let f of loc.fields">
            {{ f.label }}<span *ngIf="f.is_required"> *</span>
            <input [(ngModel)]="editForm.attributes[f.key]" [name]="'editAttr_' + f.key" [type]="f.field_type === 'number' ? 'number' : 'text'" [readonly]="!canManageLocations()" />
          </label>
        </section>

        <section class="loc-form-section loc-form-section--lidar" *ngIf="canManageLocations() && isScanEligibleType()">
          <h4 class="loc-form-section-title">LiDAR survey</h4>
          <p class="loc-form-note">{{ lidarSurveyNote() }}</p>
          <button type="button" class="btn secondary btn-compact" (click)="openLidarSurvey(loc.id)">
            Upload LiDAR scans →
          </button>
        </section>

        <section class="loc-form-section loc-form-section--plot" *ngIf="selectedTypeCode() === 'PLOT'">
          <h4 class="loc-form-section-title">Enforcement</h4>
          <p class="loc-form-note">Measurements and bye-law checks run against this plot after LiDAR is processed.</p>
          <a class="btn secondary btn-compact" routerLink="/enforcement/measurements">View measurements →</a>
        </section>

        <section class="loc-form-section loc-form-section--plot" *ngIf="selectedTypeCode() === 'PLOT' && canAccessPlotBoundaries()">
          <h4 class="loc-form-section-title">GIS boundary</h4>
          <p class="loc-form-note">Draw or upload the plot polygon for LiDAR spatial matching.</p>
          <a
            class="btn secondary btn-compact"
            [routerLink]="['/enforcement/plot-boundaries']"
            [queryParams]="{ sectorId: loc.parentLocationId, plotId: loc.id }"
          >
            Edit on map →
          </a>
        </section>

        <footer class="loc-form-actions" *ngIf="canManageLocations()">
          <button type="submit" class="btn primary" [disabled]="saving()">Save changes</button>
          <button type="button" class="btn secondary" (click)="resetEditForm()" [disabled]="saving()">Reset</button>
          <button type="button" class="btn secondary" *ngIf="childTypeForParent() as childType" (click)="openAddChild(childType)">+ Add {{ childTypeLabel(childType) }}</button>
        </footer>
      </form>
    </ng-container>
  </div>
</div>

<div class="loc-form-overlay loc-lidar-overlay" *ngIf="lidarModalOpen() && lidarModalLocationId() as lidId" (click)="closeLidarModal()">
  <div
    class="loc-form-sheet loc-lidar-sheet"
    role="dialog"
    aria-modal="true"
    aria-labelledby="locLidarTitle"
    (click)="$event.stopPropagation()"
  >
    <header class="loc-form-sheet-head">
      <div>
        <p class="loc-form-sheet-kicker" *ngIf="lidarModalLocation() as loc">{{ loc.locationTypeName }}</p>
        <h3 id="locLidarTitle">LiDAR Survey — {{ lidarModalLocation()?.name ?? 'Location' }}</h3>
        <p class="loc-lidar-sheet-lead" *ngIf="lidarModalLocation() as loc">{{ lidarSurveyNoteFor(loc) }}</p>
      </div>
      <button type="button" class="loc-form-close" (click)="closeLidarModal()" aria-label="Close">×</button>
    </header>

    <app-location-lidar-panel
      [locationId]="lidId"
      [locations]="locations()"
      [embedded]="true"
      [showHeader]="false"
      (toastMessage)="showToast($event)"
    />

    <footer class="loc-lidar-sheet-foot">
      <button type="button" class="btn secondary" (click)="closeLidarModal()">Close</button>
    </footer>
  </div>
</div>

<div class="laris-overlay" *ngIf="addModalOpen()" (click)="closeAddModal()">

  <div class="laris-modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

    <header class="laris-modal-head">

      <h3>Add location</h3>

      <p class="laris-modal-sub">Pick the type, then where it goes</p>

    </header>

    <div class="laris-modal-body">

      <p class="laris-modal-form-error" *ngIf="addFormErrors().form" role="alert">
        {{ addFormErrors().form }}
      </p>

      <p class="laris-step-label">1. What type is this?</p>

      <div class="laris-type-picker">

        <button type="button" class="laris-type-opt" *ngFor="let t of typeOptionsForAdd()" [class.laris-type-opt-active]="addForm.locationTypeId === t.id" (click)="pickAddType(t.id)">{{ t.name }}</button>

      </div>



      <p class="laris-step-label">2. Where does it go?</p>

      <label class="laris-field">

        Parent location

        <select [(ngModel)]="addForm.parentLocationId">

          <option [ngValue]="null">Top level (no parent)</option>

          <option *ngFor="let p of parentOptionsForAdd()" [ngValue]="p.id">{{ p.name }} ({{ p.locationTypeName }})</option>

        </select>

        <span class="laris-field-hint">Any location can be the parent, regardless of its type.</span>

      </label>



      <ng-container *ngIf="addTypePicked() && selectedTypeForAdd() as type">

        <p class="laris-step-label">3. Basic details</p>

        <label class="laris-field" [class.laris-field--invalid]="addFormErrors().name">
          Name *
          <input [(ngModel)]="addForm.name" placeholder="e.g. Zone 4" />
          <span class="ws-field-error" *ngIf="addFormErrors().name">{{ addFormErrors().name }}</span>
        </label>

        <label class="laris-field" [class.laris-field--invalid]="addFormErrors().code">
          Code *
          <input [(ngModel)]="addForm.code" placeholder="e.g. PDA-ZONE-4" />
          <span class="ws-field-error" *ngIf="addFormErrors().code">{{ addFormErrors().code }}</span>
        </label>



        <ng-container *ngIf="type.fields.length">

          <p class="laris-step-label">Type-specific details</p>

          <label class="laris-field" *ngFor="let f of type.fields" [class.laris-field--invalid]="addFormErrors().attributes?.[f.key]">

            {{ f.label }}<span *ngIf="f.is_required"> *</span>

            <input

              [(ngModel)]="addForm.attributes[f.key]"

              [type]="f.field_type === 'number' ? 'number' : 'text'"

            />
            <span class="ws-field-error" *ngIf="addFormErrors().attributes?.[f.key]">
              {{ addFormErrors().attributes?.[f.key] }}
            </span>

          </label>

        </ng-container>

      </ng-container>

    </div>

    <footer class="laris-modal-foot">

      <button type="button" class="btn secondary" (click)="closeAddModal()">Cancel</button>

      <button type="button" class="btn primary" (click)="submitAddLocation()" [disabled]="saving() || !addTypePicked()">Save</button>

    </footer>

  </div>

</div>

